/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownCashCardStatus } from '../models/db_DropdownCashCardStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CashCardStatuses {
    /**
     * Get a list of cash card statuses
     * @returns db_DropdownCashCardStatus OK
     * @throws ApiError
     */
    public static listCashCardStatuses(): CancelablePromise<Array<db_DropdownCashCardStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/cash-card-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
